import { Button, Result } from "antd";
import { useNavigate } from "react-router";

export const ErrorPage = () => {
  const navigate = useNavigate();

  const redirectHandler = () => {
    navigate(-1);
  };

  return (
    <Result
      status="500"
      title="500"
      subTitle="Désolé, une erreur s'est produite, veuillez réessayer."
      extra={
        <Button type="primary" onClick={redirectHandler}>
          Réessayer
        </Button>
      }
    />
  );
};
